// 数据字典数组格式化
export const oneDictDataArr = (dictObj) => {
    const dictArr = [];
    for (const i of Object.keys(dictObj)) {
        dictArr.push({
            label: dictObj[i].name,
            value: dictObj[i].code
        });
    }
    return dictArr;
};

// 处理（负百分比为正百分比）
export const formatNegative = (number) => {
    if (!number) {
        return '0%';
    }
    if (number.indexOf('-') !== -1) {
        number = number.slice(1);
    }
    return number;
};